import {
  INSERT_NEW_ROW_RESPONSAVEL,
  UPDATE_TABLE_RESPONSAVEIS_ROWS,
  EDIT_ROW_TABLE_RESPONSAVEIS,
  UPDATE_TABLE_RESPONSAVEIS_EDITED_ROW,
  RESET_RESPONSAVEIS_STATE,
  INSERT_REPRESENTANTE
} from '../actions/actionTypes';

const initialState = {
  tabelaResponsaveis: [],
  representanteLegal: {
    nome: '',
    cpf: ''
  },
  dadosEdicao: {
    editarRow: false,
    rowIndex: -1,
    rowData: null
  }
};

export const tabelaResponsaveisReducer = (state = initialState, action) => {
  switch (action.type) {
    case INSERT_NEW_ROW_RESPONSAVEL:
      return {
        ...state,
        tabelaResponsaveis: [...state.tabelaResponsaveis, action.newValue]
      };

    case UPDATE_TABLE_RESPONSAVEIS_ROWS:
      let newDadosEdicao = { ...state.dadosEdicao };

      if (newDadosEdicao.editarRow) {
        const responsavelEdicao = action.newValue.filter(
          (x) => x.cpf === newDadosEdicao.rowData.cpf
        )[0];

        if (responsavelEdicao) {
          const newIndex = action.newValue.findIndex(
            (x) => x.cpf === newDadosEdicao.rowData.cpf
          );
          newDadosEdicao.rowIndex = newIndex;
        } else {
          newDadosEdicao.editarRow = false;
          newDadosEdicao.rowIndex = -1;
          newDadosEdicao.rowData = null;
        }
      }
      return {
        ...state,
        tabelaResponsaveis: action.newValue,
        dadosEdicao: newDadosEdicao
      };

    case EDIT_ROW_TABLE_RESPONSAVEIS:
      return {
        ...state,
        dadosEdicao: action.newValue
      };

    case UPDATE_TABLE_RESPONSAVEIS_EDITED_ROW:
      const newData = [...state.tabelaResponsaveis];
      const index = state.dadosEdicao.rowIndex;
      newData[index] = action.newValue;

      return {
        ...state,
        tabelaResponsaveis: newData,
        dadosEdicao: {
          editarRow: false,
          rowIndex: -1,
          rowData: null
        }
      };

    case RESET_RESPONSAVEIS_STATE: {
      return {
        ...initialState
      }
    }

    case INSERT_REPRESENTANTE: {
      return{
        ...state,
        representanteLegal: action.newValue
      }
    }

    default:
      return state;
  }
};
